import { Routes } from '@angular/router';
import { EditUtilisateurComponent } from './pages/edit-utilisateur/edit-utilisateur.component';
import { ListeUtilisateursComponent } from './pages/liste-utilisateurs/liste-utilisateurs.component';
import { UtilisateurDroitsComponent } from './pages/utilisateur-droits/utilisateur-droits.component';

export const UTILISATEURS_ROUTE_DATA = {
    role: 'INTERVENANT_UTILISATEUR_LECTURE && (ORGANISME || ADMIN)',
    domaines: ['VIN', 'ANPP'],
    menu: {
        icon: 'users',
        libelle: 'menu.administration-utilisateurs'
    }
};

export const UTILISATEURS_ROUTES: Routes = [
    { path: '', component: ListeUtilisateursComponent },
    { path: 'add', redirectTo: 'new/edit' },
    { path: ':id/edit', component: EditUtilisateurComponent, data: { roles: ['INTERVENANT_UTILISATEUR_ECRITURE'] } },
    { path: ':id/droits', component: UtilisateurDroitsComponent, data: { roles: ['INTERVENANT_UTILISATEUR_ECRITURE'] } }
];
